var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1123 8.84562C4.6436 6.31432 8.13841 4.75 12 4.75C15.3984 4.75 18.5119 5.96136 20.9352 7.97665C21.2659 8.25169 21.5838 8.54169 21.8877 8.84562C22.1806 9.13852 22.6555 9.13852 22.9484 8.84562C23.2413 8.55273 23.2413 8.07786 22.9484 7.78496C22.6121 7.44865 22.2603 7.12773 21.8943 6.82335C19.2116 4.59235 15.7616 3.25 12 3.25C7.72461 3.25 3.85275 4.98385 1.05164 7.78496C0.758746 8.07786 0.758746 8.55273 1.05164 8.84562C1.34453 9.13852 1.8194 9.13852 2.1123 8.84562Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31786 12.0178C7.02879 10.3069 9.39026 9.25 12 9.25C14.6098 9.25 16.9712 10.3069 18.6822 12.0178C18.9751 12.3107 19.4499 12.3107 19.7428 12.0178C20.0357 11.7249 20.0357 11.2501 19.7428 10.9572C17.7621 8.97644 15.0236 7.75 12 7.75C8.97647 7.75 6.23794 8.97644 4.2572 10.9572C3.9643 11.2501 3.9643 11.7249 4.2572 12.0178C4.55009 12.3107 5.02496 12.3107 5.31786 12.0178Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52341 15.1901C9.41397 14.2995 10.6421 13.75 12 13.75C13.3579 13.75 14.5861 14.2995 15.4766 15.1901C15.7695 15.483 16.2444 15.483 16.5373 15.1901C16.8302 14.8972 16.8302 14.4223 16.5373 14.1294C15.3769 12.969 13.7717 12.25 12 12.25C10.2283 12.25 8.62311 12.969 7.46275 14.1294C7.16985 14.4223 7.16985 14.8972 7.46275 15.1901C7.75564 15.483 8.23051 15.483 8.52341 15.1901Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.832cf67519b00668546c61ef995bcb14.svg";
export { ForwardRef as ReactComponent };